import React, { PureComponent } from 'react'
import { reduxForm, Field } from 'redux-form'
import { Row, Col, Table, Button, Tooltip, OverlayTrigger, Glyphicon } from 'react-bootstrap'
import IDocCarPagination from '../../commons/iDocCarPagination'
import InputText from '../../commons/form/InputText'
import SaleTypeModalPage from '../../../containers/masters/saleType/SaleTypeModalPage'
import DuplicateSaleTypeModalPage from '../../../containers/masters/saleType/DuplicateSaleTypeModalPage'
import { handleKeyDown } from '../../../util/utils'
import MapSectionsMasters from '../../../util/map-sections-masters'
class SaleTypeMaster extends PureComponent {
  constructor () {
    super()
    this.state = {
      filter: {
        code: null,
        name: null
      }
    }
  }

  componentDidMount () {
    this.props.actions.fetchSaleTypeList(null)
  }

  getSortIcon (column = '') {
    switch (this.props.filter.orderBy) {
      case '+' + column:
        return 'ico-sort-selected-asc'
      case '-' + column:
        return 'ico-sort-selected-desc'
      default:
        return 'ico-sort'
    }
  }

  changeOrder (field) {
    switch (this.props.filter.orderBy) {
      case `+${field}`:
        this.props.actions.fetchSaleTypeList({ ...this.state.filter, ...this.props.filter, orderBy: `-${field}` })
        break
      default:
        this.props.actions.fetchSaleTypeList({ ...this.state.filter, ...this.props.filter, orderBy: `+${field}` })
        break
    }
  }

  handleCodeChange (value) {
    this.setState({ filter: { ...this.state.filter, code: value } })
  }

  handleNameChange (value) {
    this.setState({ filter: { ...this.state.filter, name: value } })
  }

  searchSaleTypeList () {
    this.props.actions.fetchSaleTypeList({ ...this.props.filter, ...this.state.filter, page: 1 })
  }

  resetFilters () {
    this.setState({
      filter: {
        code: null,
        name: null
      }
    }, () => { this.searchSaleTypeList() })
  }

  render () {
    const {
      t, saleTypeList, pagesCount, saleTypeCount, filter, fields,
      filter: { page },
      actions: { openSaleTypeModal, deleteSaleType, recoverSaleType, fetchSaleTypeList, openDuplicateSaleTypeModal }
    } = this.props

    const secMapMasters = MapSectionsMasters.find(function (s) { return s.page === 'saleTypeMastersPage' })
    const tKey = 'MASTERS.SALE_TYPE.'
    const editTooltip = (<Tooltip id="editTooltip">{t('MASTERS.EDIT')}</Tooltip>)
    const duplicateTooltip = (<Tooltip id="duplicateTooltip">{t('MASTERS.DUPLICATE')}</Tooltip>)
    const deleteTooltip = (<Tooltip id="deleteTooltip">{t('MASTERS.DELETE')}</Tooltip>)
    const recoverTooltip = (<Tooltip id="recoverTooltip">{t('MASTERS.RECOVER')}</Tooltip>)
    const hasFilters = (this.state.filter.code || this.state.filter.name)

    return (
      <div className="inner-results-panel">
        <div className="section-results-header">
          <div className="section-header-title">
            <OverlayTrigger placement="right" overlay={<Tooltip id="editProductTooltip">{`${t((this.props.hideMenu ? 'GLOBAL.TABLES.SHOW_INNER_MENU' : 'GLOBAL.TABLES.HIDE_INNER_MENU'))}`}</Tooltip>}>
              <a onClick={() => this.props.toogleInnerMenu()} className={this.props.hideMenu ? 'collapseBtn' : 'collapseBtn closeInnerMenu'}><i className={this.props.hideMenu ? 'iDocIcon-Open-inner-menu' : 'iDocIcon-Close-inner-menu'}></i></a>
            </OverlayTrigger>
            <h4>{t(`${secMapMasters.title}`)}
            </h4>
          </div>
        </div>
        <SaleTypeModalPage/>
        <DuplicateSaleTypeModalPage/>
        <Row className="section-users-header">
          <Col sm={12}>
            <div className="header-panel">
              <h4>{t(`${tKey}TITLE`)}</h4>
            </div>
          </Col>
        </Row>
        <Row>
          <div className="search-form">
            <span className="title-search"><i className="ico-uo" /> {t(`${tKey}SEARCH_TITLE`)}</span>
            <Row>
              <Field
                id="filters.name"
                name="filters.name"
                colSm={2}
                controlLabel={t(`${tKey}CODE`)}
                placeholder={t(`${tKey}CODE`)}
                component={InputText}
                onInputChange={(value) => this.handleCodeChange(value)}
              />
              <Field
                id="filters.description"
                name="filters.description"
                colSm={2}
                controlLabel={t(`${tKey}TEXT`)}
                placeholder={t(`${tKey}TEXT`)}
                component={InputText}
                onInputChange={(value) => this.handleNameChange(value)}
                maxLength={50}
              />
              <Col sm={8} className="btn-wrapper">
                <Button
                  className={'btn-white btn-icon btn-input btn-white search-button'}
                  style={{ width: '100%' }}
                  onClick={() => this.searchSaleTypeList()}
                  onKeyDown={(e) => handleKeyDown(e)}>
                  <i className="ico-search" />
                  {t(`${tKey}SEARCH_BTN`)}
                </Button>
                <Button
                  className={'btn-icon btn-input ' + (hasFilters ? 'btn-standard' : 'btn-cancel')}
                  onClick={() => {
                    this.props.initialize({})
                    this.resetFilters()
                  }}>
                  <i className="ico-cancel" />
                  {t('MASTERS.RESET_BUTTON')}
                </Button>
              </Col>
            </Row>
          </div>
        </Row>
        <Col sm={12} className="col-row  section-users-body">
          <Table className="editable-table" hover responsive>
            <thead>
              <tr>
                <th onClick={() => { this.changeOrder('code') }}>
                  {t(`${tKey}CODE`)}
                  <i className={this.getSortIcon('code')} />
                </th>
                <th onClick={() => { this.changeOrder('name') }}>
                  {t(`${tKey}NAME`)}
                  <i className={this.getSortIcon('name')} />
                </th>
                <th onClick={() => { this.changeOrder('description') }}>
                  {t(`${tKey}DESCRIPTION`)}
                  <i className={this.getSortIcon('description')} />
                </th>
                <th className="actions-sale-type-master">{t('DOSSIER_COMPONENTS.ACCESSORIES.ACTIONS')}</th>
              </tr>
            </thead>
            <tbody>
              {saleTypeList && saleTypeList.map((saleType, idx) => (
                <tr key={idx} className={saleType.isDeleted ? 'is-deleted' : ''}>
                  <td>{saleType.code}</td>
                  <td>{saleType.name}</td>
                  <td>{saleType.description}</td>
                  <td>
                    {!saleType.isDeleted ? (
                      <div>
                        <a onClick={() => openSaleTypeModal(saleType.saleTypeId)}>
                          <OverlayTrigger placement="left" overlay={editTooltip}>
                            <i className="ico-edit-white" />
                          </OverlayTrigger>
                        </a>
                        <a onClick={() => openDuplicateSaleTypeModal(saleType.saleTypeId)}>
                          <OverlayTrigger placement="right" overlay={duplicateTooltip}>
                            <span className='glyphicon glyphicon-duplicate' />
                          </OverlayTrigger>
                        </a>
                        <a onClick={() => deleteSaleType(saleType.saleTypeId)}>
                          <OverlayTrigger placement="left" overlay={deleteTooltip}>
                            <i className="ico-trash" />
                          </OverlayTrigger>
                        </a>
                      </div>
                    ) : (
                      <a onClick={() => recoverSaleType(saleType.saleTypeId)}>
                        <OverlayTrigger placement="left" overlay={recoverTooltip}>
                          <Glyphicon glyph="repeat" />
                        </OverlayTrigger>
                      </a>
                    )}
                  </td>
                </tr>
              ))}
              {(saleTypeList === null || saleTypeList === undefined || saleTypeList.length === 0) &&
            <tr>
              <td colSpan={5 + (fields ? fields.length : 0) }><h2>{t(`${tKey}RESULTS_NOT_FOUND`)}</h2></td>
            </tr>}
              <tr className="button-table-wrapper">
                <td>
                  <Button
                    className="btn-editable-table btn-standard"
                    onClick={() => openSaleTypeModal(null)}>
                  + {t('MASTERS.ADD')}
                  </Button>
                </td>
              </tr>
            </tbody>
          </Table>
          <div className="section-users-footer">
            <nav key={1} className="text-center">
              <IDocCarPagination
                id="btn_pag_finance"
                page={page}
                pagesCount={pagesCount}
                totalRows={saleTypeCount}
                onSelectAction={(value) => fetchSaleTypeList({ ...filter, ...this.state.filter, page: value })}
              />
            </nav>
          </div>
        </Col>
      </div>
    )
  }
}

export default reduxForm({
  form: 'saleTypeMaster'
})(SaleTypeMaster)
